import { InjectionToken, Signal } from '@angular/core';
import { Observable } from 'rxjs';

export interface AuthUserInfo {
  username: string;
  lang: string;
  firstname: string;
  lastname: string;
  partnertype?: number;
  user_group?: string[];
  company_name?: string;
  country: string;
  locale: string;
  zoneinfo: string;
  area_bpmid?: number;
  area_sapid_nr?: string;
  ga_bpmid?: number;
  ga_sapid?: string;
  company_sapid?: string;
  email?: string;
  roles: string[];
  company_admin?: boolean;
  mobilephonenumber?: string;
  phonenumber?: string;
  dpa_date?: string;
  dpa_responsible_person?: string;
  dpa_acceptance_required?: boolean;
  sub: string;
  bpm_company_id?: number;
  signature?: string;
  imperial_units: boolean;
  search_result_item_current_tab?: boolean;
  search_result_page_current_tab?: boolean;
}

export type AuthUserInfoValue = AuthUserInfo | undefined | null;

export interface IAuthService {
  isAuthenticated$: Observable<boolean>;
  $isAuthenticated: Signal<boolean>;
  userInfo$: Observable<AuthUserInfoValue>;
  $userInfo: Signal<AuthUserInfoValue>;
  isAccessTokenValid(): boolean;
  /**
   * @return Promise which resolves to valid access token as a string
   */
  getAccessToken(): Promise<string>;
  login(): void;
  logout(): void;
  logoutLocally(): void;
  navigateToProfile(): void;
  /**
   * Re-fetches the user profile from the identity service and pushes a fresh,
   * immutable value through `userInfo$`.
   * @returns Observable<boolean> emitting `true` when the refresh completes
   */
  refreshUserInfo(): Observable<boolean>;
}

export const AUTH_SERVICE = new InjectionToken<IAuthService>('AUTH_SERVICE');
